// extracted by mini-css-extract-plugin
module.exports = {"body":"_b6b1894"};